var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form"},[(_vm.loaded)?_c('box-alteracao',{attrs:{"data":{ initials: _vm.initials, form: _vm.form, model: _vm.model }},on:{"handleStatusAgendado":_vm.handleStatusAgendado}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }